import 'isomorphic-unfetch';
import { ApolloClient, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { PublicClientApplication } from '@azure/msal-browser';
import { SERVICE_NAME, USER_TOKEN } from '../Constants/AppConstants';
import CreateApolloCache from './Cache';

const config = {
  auth: {
    clientId: process.env.OUTLOOK_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: `${process.env.BASE_URL}index.html`,
  },
};

const pca = new PublicClientApplication(config);

async function initMsal() {
  // This is crucial to avoid the "uninitialized_public_client_application" error
  await pca.initialize();
}

async function retrieveAccount() {
  // Check if there's an active account
  let account = pca.getActiveAccount();
  if (!account) {
    // If no active account, see if we already have an account in the cache
    const accounts = pca.getAllAccounts();
    if (accounts.length > 0) {
      pca.setActiveAccount(accounts[0]);
      [account] = accounts;
    } else {
      // If no accounts are in memory, do an interactive login
      await pca.loginPopup({ scopes: ['openid'] });
      account = pca.getActiveAccount(); // Now set after login
    }
  }
  return account;
}

async function getAccessTokenSilent() {
  await initMsal();
  const account = await retrieveAccount();
  const tokenRequest = {
    scopes: ['openid'],
    account,
  };

  try {
    const response = await pca.acquireTokenSilent(tokenRequest);
    return response.idToken;
  } catch (error) {
    // if silent failed, using another method
    const interactiveResult = await pca.acquireTokenPopup(tokenRequest);
    return interactiveResult.idToken;
  }
}
const newOfficeIdentityToken = async () => {
  let accessToken;
  try {
    accessToken = await getAccessTokenSilent();
  } catch {
    accessToken = null;
  }
  return accessToken;
};

const authHeaders = async () => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(USER_TOKEN);
  let identityToken = null;
  if (!token) {
    identityToken = await newOfficeIdentityToken();
  }

  return {
    'app-info': SERVICE_NAME,
    AUTHORIZATION: identityToken,
    apikey: token || process.env.API_KEY,
  };
};

const httpLink = createHttpLink({
  uri: `${process.env.API_URL}/graphql-gateway`,
});

const authLink = setContext(async () => {
  const headers = await authHeaders();

  return {
    headers,
  };
});

const CreateApolloClient = () => {
  const cache = CreateApolloCache();

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
    resolvers: {},
  });
};

export default CreateApolloClient;
